<template>
    <div class="custom-file">
        <croppa
            v-model="croppa"
            :width="300"
            :height="300"
            :initial-image="baseImage"
            :canvas-color="'white'"
            :placeholder="'Choose an image'"
            :placeholder-font-size="0"
            :placeholder-color="'default'"
            :accept="'image/*'"
            :file-size-limit="200000"
            :quality="2"
            :zoom-speed="3"
            :disabled="false"
            :disable-drag-and-drop="false"
            :disable-click-to-choose="false"
            :disable-drag-to-move="false"
            :disable-scroll-to-zoom="false"
            :disable-rotation="false"
            :prevent-white-space="false"
            :reverse-scroll-to-zoom="false"
            :show-remove-button="false"
            @file-size-exceed="handleCroppaFileSizeExceed"
            @file-type-mismatch="handleCroppaFileTypeMismatch"
            @new-image-drawn="handleNewImageDrawn"
            @image-remove="handleImageRemove"
            @draw="handleDraw"
        ></croppa>

        <div v-if="editMode" class="mt-4">
           <div class="btn-group">
                <button class="btn btn-xs" @click.prevent="croppa.zoomIn()">
                    <b-icon-plus />
                </button>
                <button class="ml-1 btn btn-xs" @click.prevent="croppa.zoomOut()">
                    <b-icon-dash />
                </button>
                <button class="ml-1 btn btn-xs" @click.prevent="croppa.rotate()">
                    <b-icon-arrow-clockwise />
                </button>
                <button class="ml-1 btn btn-xs" @click.prevent="croppa.rotate(-1)">
                    <b-icon-arrow-counterclockwise />
                </button>

                <button class="ml-1 btn btn-xs" @click.prevent="croppa.flipX()">
                    <b-icon-align-center />
                </button>
                <button class="ml-1 btn btn-xs" @click.prevent="croppa.flipY()">
                    <b-icon-align-middle />
                </button>
                <button class="ml-1 btn btn-xs" @click.prevent="croppa.remove()">
                    <b-icon-trash />
                </button>
            </div>
            <div class="btn-group  mt-2 mt-md-0 mb-2 mb-md-0">
                <button class="ml-1 btn btn-xs" @click.prevent="addImage">
                    select new image
                </button>
            </div>
        </div>

        <div class="mt-2">
            <div v-if="fileSizeExeeded" class="invalid-feedback" style="display: block !important;">This file is too big</div>

            <button v-if="editMode && modus === 'sign-up'" class="btn btn-xs mx-auto" @click.prevent="saveImage">
                Save Image and continue
            </button>
            <button v-if="editMode && (modus === 'account' || modus === 'event')" class="btn btn-xs mx-auto" @click.prevent="saveImage">
                save image
            </button>
        </div>
    </div>

</template>

<script>
import Vue from 'vue';
import Croppa from 'vue-croppa';
import 'vue-croppa/dist/vue-croppa.css';

Vue.use(Croppa);

export default {
    name: "ImageCropper",

    props: {
        baseImage: {
            type: String,
            required: false
        },
        modus: {
            type: String,
            default: 'sign-up',
            required: false
        }
    },

    data() {
        return {
            croppa          : {},
            editMode        : false,
            fileSizeExeeded  : false,
            imageDataUrl    : null,
        }
    },

    mounted() {
        let self = this;
        jQuery(window).on('croppa-image-show-chooser', function() {
            self.addImage()
        });
    },

    methods: {
        addImage() {
            this.croppa.chooseFile();
        },
        handleNewImageDrawn() {
            this.croppa.zoomIn();
            this.croppa.zoomOut()

            this.fileSizeExeeded = false;
            this.editMode = true;

            let file = this.croppa.getChosenFile();
            if (file != null) {
                jQuery('#custom-file-browse').text(file.name);
            }

            this.showPreview();
        },
        handleImageRemove() {
            this.fileSizeExeeded = false;
            this.editMode = false;
        },
        handleDraw() {
            this.imageDataUrl = this.croppa.generateDataUrl('image/jpeg', 0.8);
            this.showPreview();
        },
        handleCroppaFileTypeMismatch() {
        },
        handleCroppaFileSizeExceed() {
            this.fileSizeExeeded = true;
        },
        saveImage() {
            let url = '/crop-image-upload';

            if (this.modus === 'account') {
                url = '/crop-image-update';
            }
            else if (this.modus === 'event') {
                url = '/crop-image-event';
            }

            Vue.axios.post(url, { 'image': this.imageDataUrl })
                .then(response => {
                    if (response.data.success) {
                        jQuery('#cropper').modal('hide');
                    }
                    console.log(response);
                });
        },
        showPreview() {
            jQuery('#preview').show().attr('src', this.imageDataUrl);
        }
    }
}
</script>

<style scoped>

</style>
